module.exports = "/assets/newsletter/bg.png?+p36giw";